import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'core-js/es6/array';
import Ionic from '@ionic/vue';
import '@ionic/core/css/ionic.bundle.css';
import './registerServiceWorker';
import Popover from 'vue-js-popover';
import 'prism-es6/components/prism-markup-templating';
import 'prism-es6/components/prism-php';
import 'prism-es6/components/prism-bash';
import 'prism-es6/components/prism-git';
import 'prism-es6/components/prism-markup';
import 'prism-es6/components/prism-sql';
import 'prism-es6/components/prism-yaml';
import 'prism-es6/themes/prism-okaidia.css';

import VueCodeHighlight from 'vue-code-highlight';

Vue.use(Ionic);
Vue.config.productionTip = false;
Vue.use(CKEditor);
Vue.use(Popover,{ tooltip: true });
Vue.use(VueCodeHighlight);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
